// Environment configuration, selected at build time from `REACT_APP_STAGE`:
//   (unset, e.g. `yarn start-*`)          -> local
//   REACT_APP_STAGE=dev react-scripts ... -> dev
//   REACT_APP_STAGE=prod react-scripts ...-> prod
//
// These values (API + per-product app domains, S3 bucket) are static and change very rarely, so they
// live in source rather than being generated from CloudFormation outputs on every backend deploy.
// Deploying the backend no longer touches the frontend; the frontend only redeploys when it changes.

type Stage = 'dev' | 'prod'
type ProductKey = 'Oversight' | 'Leavecal' | 'Tayg' | 'Subsync'

export interface EnvConfig {
	stage: Stage
	apiBaseUrl: string
	s3BaseUrl: string
	appUrls: Record<ProductKey, string>
}

const local: EnvConfig = {
	stage: 'dev',
	apiBaseUrl: 'http://api-oversight-dev.finlert.com',
	s3BaseUrl: 'doc-dev.finlert.com',
	appUrls: {
		Oversight: 'https://oversight-dev.finlert.com/',
		Leavecal: 'https://leavecal-dev.finlert.com/',
		Tayg: 'https://tayg-dev.finlert.com/',
		Subsync: 'https://subsync-dev.finlert.com/',
	},
}

const dev: EnvConfig = {
	stage: 'dev',
	apiBaseUrl: 'https://api-oversight-dev.finlert.com',
	s3BaseUrl: 'doc-dev.finlert.com',
	appUrls: {
		Oversight: 'https://oversight-dev.finlert.com/',
		Leavecal: 'https://leavecal-dev.finlert.com/',
		Tayg: 'https://tayg-dev.finlert.com/',
		Subsync: 'https://subsync-dev.finlert.com/',
	},
}

const prod: EnvConfig = {
	stage: 'prod',
	apiBaseUrl: 'https://api-oversight.finlert.com',
	s3BaseUrl: 'doc.finlert.com',
	appUrls: {
		Oversight: 'https://oversight.finlert.com/',
		Leavecal: 'https://leavecal.finlert.com/',
		Tayg: 'https://tayg.finlert.com/',
		Subsync: 'https://subsync.finlert.com/',
	},
}

const configs: Record<string, EnvConfig> = { dev, prod }

export const env: EnvConfig = configs[process.env.REACT_APP_STAGE ?? ''] ?? local
